import { Button } from "@mcleod/components";
import { AutogenLayoutEdiPartner } from "./autogen/AutogenLayoutEdiPartner";

export class EdiPartner extends AutogenLayoutEdiPartner {
    private _partnerId;
    private _version;
    private _altPartnerId;
    private _saveButton = new Button({
        id: "",
        caption: "Save",
        backgroundColor: "primary",
        color: "primary.reverse",
        minWidth: 128,
        borderWidth: 0,
        rowBreak: false,
        enabled: false,
        tooltip: "Updates made here could impact multiple profiles that use this master batch configuration."
    });
    public get partnerId() {
        return this._partnerId;
    }
    public set partnerId(value) {
        this._partnerId = value;
    }
    public get altPartnerId() {
        return this._altPartnerId;
    }
    public set altPartnerId(value) {
        this._altPartnerId = value;
    }
    public get version() {
        return this._version;
    }
    public set version(value) {
        this._version = value;
    }
    public get saveButton() {
        return this._saveButton;
    }

    public set saveButton(value: Button) {
        this._saveButton = value;
    }
}
